import { useEffect } from 'react';

export interface SEOData {
  title: string;
  description: string;
  keywords: string;
  canonicalUrl: string;
  ogType?: string;
  ogImage?: string;
}

interface SEOHeadProps {
  data: SEOData;
}

export default function SEOHead({ data }: SEOHeadProps) {
  useEffect(() => {
    const baseUrl = window.location.origin + (window.__BASE_PATH__ || '');
    const canonical = data.canonicalUrl.startsWith('http')
      ? data.canonicalUrl
      : `${baseUrl}${data.canonicalUrl}`;

    document.title = data.title;

    const setMeta = (name: string, content: string, isProperty = false) => {
      const attr = isProperty ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', data.description);
    setMeta('keywords', data.keywords);
    setMeta('og:title', data.title, true);
    setMeta('og:description', data.description, true);
    setMeta('og:type', data.ogType || 'website', true);
    setMeta('og:url', canonical, true);
    setMeta('og:site_name', '秀人写真', true);
    if (data.ogImage) setMeta('og:image', data.ogImage, true);
    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', data.title);
    setMeta('twitter:description', data.description);

    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement('link');
      link.setAttribute('rel', 'canonical');
      document.head.appendChild(link);
    }
    link.setAttribute('href', canonical);
  }, [data]);

  return null;
}